/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState, useContext } from 'react';
import { Link, Navigate } from "react-router-dom";
import { DashboardSidebar } from "./sidebar/sidebar.jsx";
import Footer from "../home/footer.jsx";
// import HeaderTwo from './newHeaderTwo.jsx';
import Navbar from '../landingpage/sections/Navbar/index.jsx';
import { doctor_14, doctor_15, doctordashboardprofile06, doctorprofileimg, doctorthumb11 } from "../imagepath.jsx";
import 'react-circular-progressbar/dist/styles.css';
import ImageWithBasePath from '../../core/img/imagewithbasebath.jsx';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { AuthContext } from '../../context/AuthContext';
import { getUserBalance } from '../../services/walletService';
import { getUserOrders } from "../../services/orderService";
import { getCelebrities } from "../../services/celebrityService";
import { toast } from 'react-toastify';
import Header from '../home/header.jsx';

const FanDashboard = (props) => {

  const { user, isLoading } = useContext(AuthContext);
  const [count, setCount] = useState(1, 2, 3, 4);
  const [animate, setAnimate] = useState(false);
  const circleRef = useRef(null);

  const sliderRef = useRef(null);

  const [balanceData, setBalanceData] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(true);

  const [currentOrders, setCurrentOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [celebritiesMap, setCelebritiesMap] = useState({});

  useEffect(() => {
    const fetchOrdersAndCelebrities = async () => {
      try {
        setOrdersLoading(true);

        // Fetch user orders
        const ordersData = await getUserOrders();

        if (ordersData && ordersData.message === "Fan celebrity requests retrieved successfully") {
          const orders = ordersData.data?.requests || [];
          setCurrentOrders(orders);

          // Build celebrities map from the celebrity data that comes with each order
          const celebMap = {};
          orders.forEach(order => {
            if (order.celebrity) {
              celebMap[order.celebrity._id] = order.celebrity;
            }
          });

          // If we didn't get enough celebrity data from orders, fetch all celebrities
          if (Object.keys(celebMap).length === 0) {
            try {
              const celebsData = await getCelebrities();
              if (celebsData.success) {
                celebsData.data.forEach(celeb => {
                  celebMap[celeb._id] = celeb;
                });
              }
            } catch (celebError) {
              console.error("Error fetching celebrities:", celebError);
            }
          }

          setCelebritiesMap(celebMap);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
        toast.error("Failed to load orders");
      } finally {
        setOrdersLoading(false);
      }
    };

    if (user) {
      fetchOrdersAndCelebrities();
    }
  }, [user]);

  // Add useEffect to fetch balance
  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const data = await getUserBalance();
        setBalanceData(data);
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        setBalanceLoading(false);
      }
    };

    if (user) {
      fetchBalance();
    }
  }, [user]);


  useEffect(() => {
    const handleScroll = () => {
      if (circleRef.current) {
        const elementPos = circleRef.current.getBoundingClientRect().top;
        const topOfWindow = window.scrollY;
        const percent = parseFloat(circleRef.current.getAttribute('data-percent'));
        const animate = circleRef.current.dataset.animate === 'true';

        if (elementPos < topOfWindow + window.innerHeight - 30 && !animate) {
          circleRef.current.dataset.animate = 'true';
          setAnimate(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger on initial load

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (isLoading) {
    return <div className="loading-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }


  const CustomNextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        className={`${className} slick-arrow slick-next`}
        onClick={onClick}
        style={{
          right: '-10px',
          zIndex: 1
        }}
      >
        <i className="fas fa-chevron-right" />
      </button>
    );
  };

  const CustomPrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        className={`${className} slick-arrow slick-prev`}
        onClick={onClick}
        style={{
          left: '-10px',
          zIndex: 1
        }}
      >
        <i className="fas fa-chevron-left" />
      </button>
    );
  };

  // const Appointments = {
  //   infinite: false,
  //   speed: 2000,
  //   autoplay: false,
  //   dots: false,
  //   arrows: true,
  //   nextArrow: <CustomNextArrow />,
  //   prevArrow: <CustomPrevArrow />,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1400,
  //       settings: {
  //         slidesToShow: 4,
  //       },
  //     },
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 4,
  //       },
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 4,
  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 3,
  //       },
  //     },
  //     {
  //       breakpoint: 550,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 0,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // };

  const Pastappointment = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // Disable default arrows completely
    dots: false,
    autoplay: false,
    speed: 500,
    adaptiveHeight: true,
  }



  return (
    <>
      <Navbar {...props} />
      <>
        {/* Breadcrumb */}
        <div className="breadcrumb-bar"
          style={{
            backgroundColor: 'var(--breadcrumb-bg)',
            transition: 'background-color 0.3s ease'
          }}
        >
          <div className="container">
            <div className="row align-items-center inner-banner">
              <div className="col-md-12 col-12 text-center">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="isax isax-home-15" />
                      </a>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Fan
                    </li>
                    <li className="breadcrumb-item active">Dashboard</li>
                  </ol>
                  <h2 className="breadcrumb-title">Welcome, {user?.fullName || 'howzit! Fan'}</h2>
                </nav>
              </div>
            </div>
          </div>
          <div className="breadcrumb-bg">
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-bg-01.png"
              alt="img"
              className="breadcrumb-bg-01"
            />
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-bg-02.png"
              alt="img"
              className="breadcrumb-bg-02"
            />
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-icon.png"
              alt="img"
              className="breadcrumb-bg-03"
            />
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-icon.png"
              alt="img"
              className="breadcrumb-bg-04"
            />
          </div>
        </div>
        {/* /Breadcrumb */}
      </>

      {/* Page Content */}
      <div className="content">
        <div className="container">
          <div className="row">
            {/* Profile Sidebar */}
            <div className="col-lg-4 col-xl-3 theiaStickySidebar">
              <div className="stickybar">
                {/* Profile Sidebar */}
                <DashboardSidebar />
                {/* /Profile Sidebar */}
              </div>
            </div>
            {/* / Profile Sidebar */}
            <div className="col-lg-8 col-xl-9">
              <div className="dashboard-header">
                <h3>Dashboard</h3>
                <ul className='header-list-btns'>
                </ul>
              </div>
              <div className="row">
                <div className="col-xl-8 d-flex">
                  <div className="dashboard-card w-100">
                    <div className="dashboard-card-head">
                      <div className="header-title">
                        <h5>Fan Details</h5>
                      </div>

                    </div>
                    <div className="dashboard-card-body">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="health-records icon-orange">
                                <span>
                                  <i className="fa-solid fa-user" />
                                  Full Name
                                </span>
                                <h3>{user?.fullName || 'N/A'}</h3>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="health-records icon-blue">
                                <span>
                                  <i className="fa-solid fa-phone" />
                                  Phone
                                </span>
                                <h6>{user?.userPhone || 'N/A'}</h6>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="health-records icon-dark-blue">
                                <span>
                                  <i className="fa-solid fa-calendar" />
                                  Age
                                </span>
                                <h6>
                                  {user?.dob ? new Date().getFullYear() - new Date(user.dob).getFullYear() : 'N/A'}
                                </h6>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="health-records icon-purple">
                                <span>
                                  <i className="fa-solid fa-film" />
                                  Favorite Entertainment
                                </span>
                                <h6>
                                  {user?.favoriteentertainment?.join(', ') || 'N/A'}
                                </h6>
                              </div>
                            </div>

                            <div className="col-lg-6 pe-lg-3">
                              <div className="health-records icon-red">
                                <span>
                                  <i className="fa-solid fa-message" />
                                  Email
                                </span>
                                <h6 className="text-break">
                                  {user?.email || 'N/A'}
                                </h6>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="health-records icon-green">
                                <span>
                                  <i className="fa-solid fa-credit-card" />
                                  Wallet Balance
                                </span>
                                <h6>
                                  {balanceLoading ? 'Loading...' : `$${balanceData?.data?.balance || 0}`}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 d-flex">
                  <Link to="/celebs" className="text-decoration-none w-100">
                    <div className="favourites-dashboard w-100 mb-2">
                      <div className="book-order-head d-flex justify-content-between align-items-center p-3 rounded"
                        style={{
                          backgroundColor: '#ff6900',
                          boxShadow: '0 2px 8px rgba(255, 105, 0, 0.2)',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          ':hover': {
                            backgroundColor: '#e55e00',
                            boxShadow: '0 4px 12px rgba(255, 105, 0, 0.3)',
                            transform: 'translateY(-2px)'
                          }
                        }}>
                        <h3 className="mb-0 text-white">
                          <span className="opacity-75" style={{ fontSize: '0.9em' }}>Make a new</span> Order
                        </h3>
                        <div className="add-icon">
                          <div style={{
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <i className="fa-solid fa-plus" style={{
                              color: '#ff6900',
                              fontSize: '1rem'
                            }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-xl-7 d-flex">
                  <div className="dashboard-main-col w-100">
                    <div className="dashboard-card dashboard-slider flex-fill">
                      <div className="dashboard-card-head">
                        <div className="header-title">
                          <h5>Recent Orders</h5>
                        </div>
                        <div className="card-view-link">
                          {/* Custom arrows in header - only show if multiple orders */}
                          {currentOrders.length > 1 && (
                            <div className="custom-slider-arrows">
                              <button
                                className="arrow-btn prev-arrow"
                                onClick={() => sliderRef.current?.slickPrev()}
                              >
                                <i className="fas fa-chevron-left" />
                              </button>
                              <button
                                className="arrow-btn next-arrow"
                                onClick={() => sliderRef.current?.slickNext()}
                              >
                                <i className="fas fa-chevron-right" />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="dashboard-card-body">
                        {ordersLoading ? (
                          <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : currentOrders.length === 0 ? (
                          <div className="text-center py-4">
                            <i className="fa-solid fa-calendar-xmark fa-2x text-muted mb-3"></i>
                            <p className="text-muted">No current orders</p>
                            <Link to="/celebs" className="btn btn-primary btn-sm">
                              Request a Shoutout
                            </Link>
                          </div>
                        ) : (
                          <div className="past-appointments-slider common-slider">
                            <Slider {...Pastappointment} ref={sliderRef}>
                              {currentOrders.map((order) => {
                                const celebrity = celebritiesMap[order.celebrityId?._id || order.celebrityId];
                                const orderDate = order.deliveryDate ? new Date(order.deliveryDate) : new Date(order.createdAt);

                                return (
                                  <div key={order._id} className="appointment-dash-card past-appointment mt-0">
                                    <div className="doctor-fav-list">
                                      <div className="doctor-info-profile">
                                        <Link to="#" className="table-avatar">
                                          {celebrity?.profilepicture ? (
                                            <img
                                              src={celebrity.profilepicture}
                                              alt={celebrity.displayName || celebrity.fullName}
                                              style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }}
                                              onError={(e) => {
                                                e.target.src = "assets/img/doctors-dashboard/doctor-profile-img.jpg";
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src="assets/img/doctors-dashboard/doctor-profile-img.jpg"
                                              alt="Celebrity"
                                              style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }}
                                            />
                                          )}
                                        </Link>
                                        <div className="doctor-name-info">
                                          <h5>
                                            <Link to="#">{celebrity?.displayName || celebrity?.fullName || "Unknown Celebrity"}</Link>
                                          </h5>
                                          <span>{celebrity?.category || "Entertainer"}</span>
                                        </div>
                                      </div>
                                      <span className="bg-orange badge">
                                        <i className="isax isax-video me-1" />
                                        {order.messageType || "Video"}
                                      </span>
                                    </div>
                                    <div className="appointment-date-info">
                                      <h6>{orderDate.toLocaleDateString('en-US', {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric'
                                      })}</h6>
                                      <ul className='p-0'>
                                        <li>
                                          <span>
                                            <i className="isax isax-clock5" />
                                          </span>
                                          Time : {orderDate.toLocaleTimeString('en-US', {
                                            hour: '2-digit',
                                            minute: '2-digit'
                                          })}
                                        </li>
                                        {order.recipientName && (
                                          <li>
                                            <span>
                                              <i className="isax isax-user me-1" />
                                            </span>
                                            For: {order.recipientName}
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                    <div className="card-btns">
                                      <Link
                                        to={`/order/${order._id}`}
                                        state={{ order: order }}
                                        className="btn btn-md btn-primary-gradient rounded-pill"
                                      >
                                        View Details
                                      </Link>
                                    </div>
                                  </div>
                                );
                              })}
                            </Slider>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
      <Footer {...props} />
    </>
  );
};

export default FanDashboard;
